import React from 'react'
import { FUEL_DEFAULT_COLOR, DEFAULT_FUEL_ID } from '../../store/geoentity/geoentity.constants'
import { selectFuelInformation } from '../../store/geoentity/fuels.selectors'
import { useSelector } from 'react-redux'
import { getFuelLabelFromId, getFuelPriceDisplayValue } from '../../store/geoentity/geoentity.helpers'
import s from './GeoentityFuelListItem.less'
import classNames from 'classnames'

const GeoentityFuelCard = ({ fuel, opacity }) => {
  const fuelInformations = useSelector(selectFuelInformation)
  const matchingFuelInformation = fuelInformations?.find(fuelInfo => fuelInfo.id === fuel.id) ?? {}

  const { color } = matchingFuelInformation
  const fuelName = getFuelLabelFromId(fuel.id ?? DEFAULT_FUEL_ID)
  const fuelColor = color?.hex ?? FUEL_DEFAULT_COLOR

  if (!matchingFuelInformation) return <></>

  return (
    <div className={classNames(s.gasPrice, opacity && s.gasPriceOpacity)} style={{ borderColor: fuelColor }}>
      <div className={s.gasName} style={{ backgroundColor: fuelColor }}>
        <span className={s.gasNameContent}>{fuelName}</span>
      </div>
      <div className={s.gasPriceText}>{getFuelPriceDisplayValue(fuel)}</div>
    </div>
  )
}

export default GeoentityFuelCard
